<template>
<div class="mMenu-container" :class="{hideMenu: scrollingDown}">
  <div class="space-gap"></div>
  <div class="mHeader-section">
    <div class="mHeader-container">

      <div class="mLogo-container">
        <img
          @click="selectMobileOption('flavors')"
          :src="icon"
          alt="Logo de Strongbow"
        />
      </div>




      <div class="menu">
                <div
          @click="selectMobileOption('flavors')"
          :class="{ active: getActiveSection === 'flavors' }"
        >
          <h2>HOME</h2>
        </div>
        <div
          @click="selectMobileOption('goldApple')"
          :class="{ active: getActiveSection === 'goldApple' }"
        >
          <h2>GOLD APPLE</h2>
        </div>
                <div
          @click="selectMobileOption('redBerries')"
          :class="{ active: getActiveSection === 'redBerries' }"
        >
          <h2>RED BERRIES</h2>
        </div>
        <div
          @click="selectMobileOption('honey')"
          :class="{ active: getActiveSection === 'honey' }"
        >
          <h2>HONEY</h2>
        </div>

        <div
          @click="selectMobileOption('roseApple')"
          :class="{ active: getActiveSection === 'roseApple' }"
        >
          <h2>ROSÉ APPLE</h2>
        </div>
      </div>
      <div class="social-networks">
        <a
          id="twitter"
          class="social-icon"
          target="_blank"
          rel="noopener"
          href="https://twitter.com/strongbowmx?lang=es" @click="socialClick('Twitter','Interaction')"
          ><img :src="twIconImage" alt="Twitter"
        /></a>
        <a
          id="instagram"
          class="social-icon"
          target="_blank"
          rel="noopener"
          href="https://www.instagram.com/strongbow/" @click="socialClick('Instagram','Interaction')"
          ><img :src="inIconImage" alt="Instagram"
        /></a>
        <a
          id="facebook"
          class="social-icon"
          target="_blank"
          rel="noopener"
          href="https://www.facebook.com/StrongbowMX/" @click="socialClick('Facebook','Interaction')"
          ><img :src="fbIconImage" alt="Facebook"
        /></a>
        <a
          id="youtube"
          class="social-icon"
          target="_blank"
          rel="noopener"
          href="javascript:void(0)" @click="socialClick('Youtube','Interaction')"
          ><img :src="ytIconImage" alt="Youtube"
        /></a>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import icon from "@/assets/Logo_Strongbow.png";
import fbIcon from "@/assets/facebook.png";
import twIcon from "@/assets/twitter.png";
import ytIcon from "@/assets/youtube.png";
import inIcon from "@/assets/instagram.png";

import { mapActions, mapGetters } from "vuex";
import tagFunctions from '@/utils/tagFunctions.js'

export default {
  name: "Menu",
  computed: {
    ...mapGetters(["getActiveSection"]),
  },
  methods: {
    ...mapActions({
      setActiveSection: "setActiveSection",
    }),
    socialClick(socialNetwork, action){
      tagFunctions.evSocialNetworkPush(socialNetwork, action)
    },
    openMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    selectHomeOption(option) {
      this.setActiveSection({
        willScroll: true,
        section: option,
      });
    },
    selectMobileOption(option) {
      this.setActiveSection({
        willScroll: true,
        section: option,
      });
      this.$router.push({ name: option }).catch(err => {
    // Ignore the vuex err regarding  navigating to the page they are already on.
    if (
      err.name !== 'NavigationDuplicated' &&
      !err.message.includes('Avoided redundant navigation to current location')
    ) {
      // But print any other errors to the console
      throw err;
    }
  });
      this.openMenu();
    },
  },
  data() {
    return {
      isMenuOpen: false,
      icon,
      fbIconImage: fbIcon,
      twIconImage: twIcon,
      ytIconImage: ytIcon,
      inIconImage: inIcon,
      scrollingDown: false,
    };
  },
  mounted(){
    var lastScrollTop = window.pageYOffset;

window.addEventListener("scroll", () => { 
   var st = window.pageYOffset || document.documentElement.scrollTop; 
   if (st > lastScrollTop){
      // downscroll code
      this.scrollingDown= true;
   } else {
      // upscroll code
      this.scrollingDown= false;
   }
   lastScrollTop = st <= 0 ? 0 : st; 
}, false);
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/Menu.scss";
</style>
